import { Permission } from "../../../types/Permissions";
import { authDelete, authGet, authPost, authPut } from "../../auth/auth";
import { ActionBody, ActionResponse, ActionTestResponse } from "./types";

/**
 * Fetch actions from deploymentId provided user has permission
 * Recommended that you use the useActions hook instead of directly calling this function
 */
export const fetchActionsIfPermitted = (
  deploymentId: string,
  permissions: Permission[]
) => {
  if (!permissions.includes(Permission.panel_policy)) {
    return Promise.resolve([]);
  }

  return authGet<ActionResponse[]>(
    `/api/agent/deployments/${deploymentId}/actions`
  );
};

/**
 * Sends request to create a new action with actionBody
 * Recommended that you use the useDeleteAction react-query mutation instead
 */
export const createAction = (deploymentId: string, actionBody: ActionBody) => {
  return authPost<ActionBody, ActionResponse>(
    `/api/agent/deployments/${deploymentId}/actions`,
    actionBody
  );
};

/**
 * Sends request to update the action with id actionId
 * Recommended that you use the useDeleteAction react-query mutation instead
 */
export const updateAction = (
  deploymentId: string,
  actionId: number,
  actionBody: ActionBody
) => {
  return authPut<ActionBody, ActionResponse>(
    `/api/agent/deployments/${deploymentId}/actions/${actionId}`,
    actionBody
  );
};

export const testAction = (deploymentId: string, actionId: number) => {
  return authPost<{}, ActionTestResponse>(
    `/api/agent/deployments/${deploymentId}/actions/${actionId}/test`,
    {}
  );
};

/**
 * Sends request to delete the action with id actionId
 * Recommended that you use the useDeleteAction react-query mutation instead
 */
export const deleteAction = (deploymentId: string, actionId: number) => {
  return authDelete<ActionResponse>(
    `/api/agent/deployments/${deploymentId}/actions/${actionId}`
  );
};
